import { render, staticRenderFns } from "./RequestDocumentsPro.vue?vue&type=template&id=cb4c018e&scoped=true"
import script from "./RequestDocumentsPro.vue?vue&type=script&lang=js"
export * from "./RequestDocumentsPro.vue?vue&type=script&lang=js"
import style0 from "./RequestDocumentsPro.vue?vue&type=style&index=0&id=cb4c018e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4c018e",
  null
  
)

export default component.exports